import React from 'react'
import styles from './styles.module.scss'

interface ITag {
  label: string
  value: 'active' | 'inactive'
}

const Tag: React.FC<ITag> = ({ label = 'Activo', value }) => {
  return <div className={`${styles.tag} rankmiTemplateTag-${value}`}>{label}</div>
}

export default Tag
